import { useState } from 'react';

import { Tabs, Tab } from '@mui/material';

import _ from 'lodash';

import PropTypes from 'prop-types';

import { Button, FadeInAnimation } from '../../shared';

import useResponsive from '../../../../utils/responsive';

import LeadGenRequestCallBackForm from '../../get-in-touch-components/lead-gen-request-call-back-form.component';

const RoomTypeDescription = (props) => {
    const { selectedRoomType, buildingName, renderTimeToConnectForm, roomTypeDescription } = props;
    const details = _.get(selectedRoomType, 'details');
    const [activeValue, setActiveValue] = useState(0);
    const { isMobile } = useResponsive();

    const onVideoTourClick = () => {
        const element = document.getElementById('video-tour-section');
        element.scrollIntoView();
    };

    const LinkTab = (linkTabProps) => {
        const { activeVal, ...rest } = linkTabProps;
        return (
            <Tab
                className='room-types-description-tab'
                component="a"
                onMouseEnter={() => setActiveValue(activeVal)}
                onMouseLeave={() => setActiveValue(0)}
                {...rest}
            />
        );
    };

    const renderListNav = () => {
        if (isMobile) {
            return null;
        }
        return (
            <FadeInAnimation>
                <Tabs value={activeValue} id="room-type-description-nav" className='room-types-description-navigation-tabs'>
                    <LinkTab
                        label="HOMii Living"
                        id="homii-living-list-button"
                        href="#homii-living-section"
                        activeVal={0}
                    />
                    <LinkTab
                        label="Location"
                        id="location-list-button"
                        href="#location-section"
                        activeVal={1}
                    />
                    <LinkTab
                        label="Reviews"
                        id="review-list-button"
                        href="#review-section"
                        activeVal={2}
                    />
                    <LinkTab
                        label="About"
                        id="about-list-button"
                        href="#about-building-section"
                        activeVal={3}
                    />
                </Tabs>
            </FadeInAnimation>
        );
    };

    const renderDetails = () => {
        if (!details) {
            return null;
        }
        return (
            <FadeInAnimation>

                {renderTimeToConnectForm && (
                    <LeadGenRequestCallBackForm
                        buildingName={buildingName}
                        roomTypeDescription={roomTypeDescription}
                    />
                )}

                <div>
                    <h3 className='room-types-description-header3'>The Details</h3>
                    <p className='room-types-description-details'>{details}</p>
                    {renderVideoTourButton()}
                    <hr className='room-types-description-hr' />
                </div>
            </FadeInAnimation>
        );
    };

    const renderVideoTourButton = () => {
        const videoTourUrl = _.get(selectedRoomType, 'videoTourUrl');
        if (!videoTourUrl) {
            return null;
        }
        return (
            <Button
                type="secondary"
                id="watch-video-tour-button"
                startIcon={
                    <img
                        src="/assets/images/video-tour-icon.png"
                        alt="gallery_icon"
                        className='room-types-description-video-tour-icon'
                    />
                }
                onClick={onVideoTourClick}
            >
                Watch Video Tour
            </Button>
        );
    };

    return (
        <>
            {renderListNav()}
            {renderDetails()}
        </>
    );
};

export default RoomTypeDescription;

RoomTypeDescription.propTypes = {
    selectedRoomType: PropTypes.object,
    buildingName: PropTypes.string,
    renderTimeToConnectForm: PropTypes.bool,
    roomTypeDescription: PropTypes.string,
};

